import { IAccountLog } from 'interfaces';

export interface IAccountLogWithBalance extends IAccountLog {
  accountBalance: number;
  user?: string;
  receivingBank?: string;
}

export enum EUserType {
  Client = 'Client',
  Supplier = 'Supplier',
}

export enum ETransactionType {
  Sale = 'Sale',
  Purchase = 'Purchase',
  PaymentReceived = 'Payment_Received',
  Refund = 'Refund',
  Return = 'Return',
}

export interface IOptionGroup {
  value: string;
  label: string | React.ReactNode;
}

export type SearchKeywords = {
  id: string[];
};

export interface ISearchObject {
  query?: string;
  transactionType?: ETransactionType;
}
